module.exports = __webpack_public_path__ + "static/media/ami_ch.f8e45f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_ch.png
// module id = 568
// module chunks = 1